import React, { useMemo, useState } from 'react';
import { Typography, Box, useMediaQuery } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import classNames from 'classnames';
import toast from 'react-hot-toast';
import { ISinglePro } from '../../../components/singlePro/state';
import { ExpertFormMenu } from './ExpertFormMenu';
import axiosInstant from '../../../api';
import config from '../../../config';
import { ConfirmationDialog } from '../../../components/ConfirmationDialog/ConfirmationDialog';

interface Props {
  isDialog: boolean;
  create?: boolean;
  pro?: ISinglePro | null;
}
export default function ExpertFormHeader({
  create = false,
  isDialog = false,
  pro,
}: Props) {
  const navigate = useNavigate();
  const isMobile = useMediaQuery('(max-width: 600px)');
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);

  const deleteUser = () => {
    if (!pro?.userid) return;
    axiosInstant
      .delete(`${config.API_URL}/proteam/users/${pro?.userid}`)
      .then(() => {
        toast.success('User has been successfully removed.');
      })
      .catch(() => {
        toast.error('Something went wrong. Try again.');
      })
      .finally(() => {
        setShowDeleteConfirm(false);
        navigate('/experts');
      });
  };

  const title = useMemo(() => {
    if (create) {
      if (isMobile) return 'Create Expert';
      return 'Create new pro expert profile';
    }
    return pro?.displayName;
  }, [pro, create, isMobile]);

  return (
    <div className={classNames({ 'px-8': isDialog })}>
      <Box
        className="w-full flex justify-between items-center gap-3 relative"
        marginTop={2}
      >
        <Typography
          variant="h4"
          sx={{
            fontSize: { xs: '1.5rem', sm: '2.125rem' },
            overflow: { xs: 'hidden', sm: 'visible' },
            textOverflow: { xs: 'ellipsis', sm: 'clip' },
            whiteSpace: { xs: 'nowrap', sm: 'normal' },
            minWidth: 0,
            flex: { xs: 1, sm: 'initial' },
          }}
        >
          {title}
        </Typography>
        {pro && !create && (
          <ExpertFormMenu id={pro?.userid} onDelete={() => setShowDeleteConfirm(true)} pro={pro}/>
        )}
      </Box>
      <ConfirmationDialog
        open={showDeleteConfirm}
        onClose={() => setShowDeleteConfirm(false)}
        onConfirm={deleteUser}
        title="Delete User"
        description="Are you sure you want to delete this user?"
        confirmLabel="Delete"
      />
    </div>
  );
}
